import { tap, finalize, Observable, MonoTypeOperatorFunction, Subject } from 'rxjs';
import { LoaderType } from '../types/loader.type';

export const loaderStart$ = new Subject<LoaderType>();
export const loaderStop$ = new Subject<LoaderType>();

export const finalizeLoader = <T>(loader: LoaderType): MonoTypeOperatorFunction<T> => {
    return (source: Observable<T>): Observable<T> => {
        return source.pipe(
            tap({
                subscribe: (): void => {
                    loaderStart$.next(loader);
                },
            }),
            finalize((): void => {
                loaderStop$.next(loader);
            }),
        );
    };
};
